import { SITE } from "../data/site";

export function buildOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${SITE.url}/#organization`,
        name: SITE.name,
        url: SITE.url,
        logo: SITE.logo,
        image: SITE.image,
        email: SITE.email,
        founder: {
          "@type": "Person",
          name: SITE.founder,
        },
      },
      {
        "@type": "ProfessionalService",
        "@id": `${SITE.url}/#professional-service`,
        name: SITE.name,
        url: SITE.url,
        image: SITE.image,
        description: SITE.description,
        areaServed: SITE.areaServed,
        address: {
          "@type": "PostalAddress",
          addressLocality: SITE.locality,
          addressRegion: SITE.region,
          addressCountry: SITE.country,
        },
        contactPoint: {
          "@type": "ContactPoint",
          email: SITE.email,
          contactType: "customer support",
          areaServed: SITE.areaServed,
          availableLanguage: "English",
        },
        provider: {
          "@id": `${SITE.url}/#organization`,
        },
      },
      {
        "@type": "WebSite",
        "@id": `${SITE.url}/#website`,
        name: SITE.name,
        url: SITE.url,
        description: SITE.description,
        publisher: {
          "@id": `${SITE.url}/#organization`,
        },
      },
    ],
  };
}

export function buildWebPageSchema({ title, description, canonical, type = "WebPage" }) {
  return {
    "@context": "https://schema.org",
    "@type": type,
    "@id": `${canonical}#webpage`,
    name: title,
    url: canonical,
    description,
    isPartOf: {
      "@id": `${SITE.url}/#website`,
    },
    about: {
      "@id": `${SITE.url}/#professional-service`,
    },
  };
}

export function buildBreadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function buildItemListSchema({ name, items }) {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name,
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      url: item.url,
    })),
  };
}

export function buildServiceSchema({ name, description, canonical, offerLabel, serviceType }) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    name,
    description,
    url: canonical,
    serviceType: serviceType || name,
    provider: {
      "@id": `${SITE.url}/#professional-service`,
    },
    areaServed: SITE.areaServed,
  };

  if (offerLabel) {
    schema.offers = {
      "@type": "Offer",
      priceSpecification: {
        "@type": "PriceSpecification",
        priceCurrency: "USD",
        description: offerLabel,
      },
    };
  }

  return schema;
}

export function buildPersonSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Person",
    name: SITE.founder,
    jobTitle: "Founder",
    worksFor: {
      "@id": `${SITE.url}/#organization`,
    },
  };
}

export function buildContactPageSchema(canonical) {
  return {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    name: `Contact ${SITE.name}`,
    url: canonical,
    mainEntity: {
      "@id": `${SITE.url}/#professional-service`,
    },
  };
}

export function buildOfferCatalogSchema(canonical) {
  return {
    "@context": "https://schema.org",
    "@type": "OfferCatalog",
    name: `${SITE.name} pricing`,
    url: canonical,
    provider: {
      "@id": `${SITE.url}/#professional-service`,
    },
  };
}
